import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import x_mark from "../../../../assets/images/courses/group.svg";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import PaginatedItems from "../../../../components/tables/paginationResult";
import Repository from "../../../../configs/axios/repository";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import ResultTable from "../../../../components/tables/resultTable";

const Result = (props) => {
    const location = useLocation();
    const testType = location.state?.testType;
    let isData = location.state?.isData;
    let noteData = location.state?.noteData;
    let canDoIt = location.state?.canDoIt;
    let course_id = location.state?.course_id;
    let courseName = location.state?.courseName;
    const role = useSelector((state) => state.layout.role);
    const queryParameters = new URLSearchParams(window.location.search);
    const test_id = queryParameters.get("test_id");
    const note_id = queryParameters.get("note_id");
    let getTikets = localStorage.getItem("getTikets");
    let tiketData = JSON.parse(getTikets);
    let notes = tiketData?.test_prompt;
    const [loadingData, setLoadingData] = useState(true);
    const [array, setArray] = useState([]);
    const history = useHistory();

    const findTestsById = async () => {
        setLoadingData(false);
        const result = await Repository.findByEndPoint(
            `api/resultTest/findResultTestByTestId/${test_id}`
        );

        if (result.data.success == true) {
            setArray(result.data.data);
        }
        setLoadingData(true);
    };

    useEffect(() => {
        findTestsById();
    }, []);

    return loadingData ? (
        <div className="testBodyDiv homeSection">
            <div className=" resultCard">
                <div>
                    <div className="resultHeaderResult">
                        <h1>Results</h1>
                        <div className="nextBtnDiv restmarg">
                            <button
                                className="mt-1"
                                onClick={() => {
                                    history.push({
                                        pathname: "/tests",
                                        state: {
                                            note_id,
                                            notes,
                                            testType,
                                            noteData,
                                            canDoIt,
                                            course_id,
                                            courseName,
                                        },
                                    });
                                }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                </div>
                <ResultTable
                    array={array}
                    refreshTable={findTestsById}
                    setLoadingData={setLoadingData}
                    loadingData={loadingData}
                    test_id={test_id}
                    testType={testType}
                    note_id={note_id}
                    noteData={noteData}
                    canDoIt={canDoIt}
                />
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default Result;
